import Goods from '../service/goods'
import RequestUtils from '../../store/requestUtils'
export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    getgoodslist(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Goods.getgoodslist(payload), {
        type: 'list',
        success,
        fail
      })
    },
    getgoods(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Goods.getgoods(payload), {
        type: 'info',
        success,
        fail
      })
    },
    deletegoods(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Goods.deletegoods(payload), {
        type: 'action',
        success,
        fail
      })
    },
    upshelfgoods(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Goods.upshelfgoods(payload), {
        type: 'action',
        success,
        fail
      })
    },
    downshelfgoods(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Goods.downshelfgoods(payload), {
        type: 'action',
        success,
        fail
      })
    },
    addgoods(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Goods.addgoods(payload), {
        type: 'action',
        success,
        fail
      })
    },
    updategoods(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Goods.updategoods(payload), {
        type: 'action',
        success,
        fail
      })
    },
    modifystoragecount(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Goods.modifystoragecount(payload), {
        type: 'action',
        success,
        fail
      })
    }
  }
}
